import Vue from "vue";
import Router from "vue-router";
import index from "@/view/index";
import acq from "@/view/product/acq";
import account from "@/view/product/account";
import payment from "@/view/product/payment";
import system from "@/view/technology/system";
import tool from "@/view/technology/tool";
import about from "@/view/about";
import contactUs from "@/view/contact-us";
import news from "@/view/news";
import newsDetails from "@/view/newsDetails";
import login from "@/view/login";
import privacyPolicy from "@/view/privacyPolicy";
import statement from "@/view/statement";
import termUse from "@/view/termUse";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "index",
    component: index
  },
  {
    path: "/acq",
    name: "acq",
    component: acq
  },
  {
    path: "/account",
    name: "account",
    component: account
  },
  {
    path: "/payment",
    name: "payment",
    component: payment
  },
  {
    path: "/system",
    name: "system",
    component: system
  },
  {
    path: "/tool",
    name: "tool",
    component: tool
  },
  {
    path: "/about",
    name: "about",
    component: about
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: contactUs
  },
  {
    path: "/news",
    name: "news",
    component: news
  },
  {
    path: "/newsDetails",
    name: "newsDetails",
    component: newsDetails
  },
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: privacyPolicy
  },
  {
    path: "/statement",
    name: "statement",
    component: statement
  },
  {
    path: "/termUse",
    name: "termUse",
    component: termUse
  }
];

const router = new Router({
  mode: "hash", // 设置为history模式
  routes // （缩写）相当于 routes: routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js